import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './context/AuthContext.jsx';
import App from './App.jsx';
import i18n from './i18n/index.js';
import { errorMessage, errorStatus } from './services/api.js';
import { notify } from './services/notify.js';
import './styles/index.css';

// A 401 is already handled by the axios interceptor, which clears the session
// and sends the user to the login screen; a toast on top of that is noise.
const reportError = (error) => {
  if (errorStatus(error) === 401) return;
  notify.error(errorMessage(error, i18n.t('common.requestFailed')));
};

const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: reportError }),
  mutationCache: new MutationCache({ onError: reportError }),
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
